import script from "./BindingTab.vue?vue&type=script&setup=true&lang=js"
export * from "./BindingTab.vue?vue&type=script&setup=true&lang=js"

import "./BindingTab.vue?vue&type=style&index=0&id=51e6f422&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e6f422"]])

export default __exports__